const n = `:deep(.n-input--focus){--n-border: none !important;--n-border-focus: none !important;--n-box-shadow-focus: none !important;--n-box-shadow: none !important;border:none!important}
`;
export {
  n as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/house-type-edit-dialog/houseTypeEditDialog.ce.vue3.js
// module id = 1255
// module chunks = 41